export const FETCH_DELETE_PROJECT_TEMPLATE_TASK_LANE_REQUEST = 'FETCH_DELETE_PROJECT_TEMPLATE_TASK_LANE_REQUEST'
export const FETCH_DELETE_PROJECT_TEMPLATE_TASK_LANE_SUCCESS = 'FETCH_DELETE_PROJECT_TEMPLATE_TASK_LANE_SUCCESS'
export const FETCH_DELETE_PROJECT_TEMPLATE_TASK_LANE_FALUIRE = 'FETCH_DELETE_PROJECT_TEMPLATE_TASK_LANE_FALUIRE'
